/*
 * Jmary – erişilebilirlik iyileştirmeleri
 * Kalles'in kendi JS'ine dokunmadan, onun ürettiği işaretlemeyi klavye ve
 * ekran okuyucu için kullanılabilir hale getirir.
 */
(function () {
  'use strict';

  /* ---------- Varyant seçiciler (role="radio" swatch öğeleri) ---------- */

  var SWATCH = '[data-swatch-item][role="radio"]';
  var NEXT_KEYS = ['ArrowRight', 'ArrowDown'];
  var PREV_KEYS = ['ArrowLeft', 'ArrowUp'];

  function groupItems(item) {
    return Array.prototype.slice.call(item.parentElement.querySelectorAll(SWATCH));
  }

  function syncChecked(item) {
    var checked = item.classList.contains('is--selected');
    item.setAttribute('aria-checked', checked ? 'true' : 'false');
    item.setAttribute('aria-disabled', item.classList.contains('is--unavailable') ? 'true' : 'false');
  }

  document.addEventListener('keydown', function (event) {
    var item = event.target.closest && event.target.closest(SWATCH);
    if (!item) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      item.click();
      return;
    }

    var step = NEXT_KEYS.indexOf(event.key) > -1 ? 1 : PREV_KEYS.indexOf(event.key) > -1 ? -1 : 0;
    if (!step) return;

    event.preventDefault();
    var items = groupItems(item);
    var target = items[(items.indexOf(item) + step + items.length) % items.length];
    target.focus();
    target.click();
  });

  // Kalles seçimi "is--selected" sınıfıyla işaretler; aria-checked'i onunla eşitle.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.matches && mutation.target.matches(SWATCH)) syncChecked(mutation.target);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(SWATCH).forEach(syncChecked);
  });

  /* ---------- Buton rolündeki bağlantı ve div'ler ---------- */
  // a[role=button] (kart "Sepete Ekle"): Enter zaten çalışır, Boşluk eklenir.
  // div[role=button] (mini sepet araçları): Enter ve Boşluk eklenir.
  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    var el = event.target.closest && event.target.closest('[role="button"]');
    if (!el || el.tagName === 'BUTTON' || el !== event.target) return;
    if (el.tagName === 'A' && event.key === 'Enter') return;
    event.preventDefault();
    el.click();
  });

  /* ---------- Çekmeceler (menü, mini sepet, arama, giriş) ---------- */
  // Kalles yalnızca aria-hidden'ı değiştirir. Burada: diyalog rolü, açılınca
  // odak içeri, Tab içeride döner, kapanınca odak açan öğeye geri döner.
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-drawer-options], [data-menu-drawer]');
    if (trigger) lastTrigger = trigger;
  }, true);

  function focusables(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (node) {
      return node.offsetParent !== null;
    });
  }

  function onDrawerOpen(drawer) {
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.hasAttribute('aria-label') && !drawer.hasAttribute('aria-labelledby')) {
      var title = drawer.querySelector('.t4s-drawer__header h3, .t4s-drawer__header h2, .t4s-drawer__header span, h2, h3');
      if (title && title.textContent.trim()) drawer.setAttribute('aria-label', title.textContent.trim().slice(0, 60));
    }
    drawer.jmReturnFocus = lastTrigger || document.activeElement;
    lastTrigger = null;
    // Çekmece açılış animasyonu bitene ve içerik (AJAX) yüklenene kadar birkaç kez dene
    var attempts = 0;
    (function tryFocus() {
      if (drawer.getAttribute('aria-hidden') !== 'false' || drawer.contains(document.activeElement)) return;
      var target = drawer.querySelector('[data-drawer-close]') || focusables(drawer)[0];
      if (target) target.focus({ preventScroll: true });
      if (!drawer.contains(document.activeElement) && ++attempts < 8) setTimeout(tryFocus, 150);
    })();
  }

  function onDrawerClose(drawer) {
    var back = drawer.jmReturnFocus;
    drawer.jmReturnFocus = null;
    if (back && document.contains(back) && typeof back.focus === 'function') back.focus({ preventScroll: true });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var drawer = mutation.target;
      if (!drawer.classList || !drawer.classList.contains('t4s-drawer')) return;
      var open = drawer.getAttribute('aria-hidden') === 'false';
      if (open && !drawer.jmOpen) {
        drawer.jmOpen = true;
        onDrawerOpen(drawer);
      } else if (!open && drawer.jmOpen) {
        drawer.jmOpen = false;
        onDrawerClose(drawer);
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var drawer = document.querySelector('.t4s-drawer[aria-hidden="false"]');
    if (!drawer) return;
    var items = focusables(drawer);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!drawer.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Sepete ekleme duyurusu (aria-live) ---------- */
  // Kalles olayları jQuery(document) üzerinde tetikler.
  document.addEventListener('DOMContentLoaded', function () {
    var live = document.getElementById('jm-live');
    var $ = window.jQuery_T4NT;
    if (!live || !$) return;
    var announce = function (text) {
      live.textContent = '';
      setTimeout(function () { live.textContent = text; }, 50);
    };
    $(document).on('add:cart:success', function () { announce(live.getAttribute('data-added')); });
    $(document).on('cart:updated', function (event, status) {
      if (status === 'error') announce(live.getAttribute('data-error'));
    });
  });
})();
